module.exports = __webpack_public_path__ + "static/media/vip_room_min_0.9e0318fc.png";